var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "create"
    ? _c(
        "div",
        {
          staticClass:
            "row l-m-b-16 bg-light border-top border-bottom text-center"
        },
        [
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              {
                staticClass:
                  "text-center d-inline-block px-4 py-2 text-white companies-check-field",
                class: [
                  _vm.step === "companies-map"
                    ? "bg-primary check-default"
                    : "text-dark"
                ]
              },
              [
                _c(
                  "label",
                  {
                    class: [
                      _vm.savedCoverage === true
                        ? "check-closed pointer"
                        : "check-open"
                    ],
                    attrs: { for: "companies-map" },
                    on: {
                      click: function($event) {
                        _vm.savedCoverage === true
                          ? _vm.setCompanyStep("companies-map")
                          : null
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "companies-checkmark" }),
                    _vm._v(" "),
                    _c("input", {
                      attrs: {
                        type: "checkbox",
                        value: "companies-map",
                        id: "companies-map"
                      },
                      domProps: { checked: _vm.savedCoverage === true }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "company-steps-title",
                        class: { "text-white": _vm.step === "companies-map" }
                      },
                      [_vm._v("\n          Coverage")]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "text-center d-inline-block px-4 py-2 text-white companies-check-field",
                class: [
                  _vm.step === "companies-settings"
                    ? "bg-primary check-default"
                    : "text-dark"
                ]
              },
              [
                _c(
                  "label",
                  {
                    class: [
                      _vm.savedSettings === true
                        ? "check-closed pointer"
                        : "check-open",
                      { pointer: _vm.savedCoverage === true }
                    ],
                    attrs: { for: "companies-settings" },
                    on: {
                      click: function($event) {
                        _vm.savedSettings === true || _vm.savedCoverage === true
                          ? _vm.setCompanyStep("companies-settings")
                          : null
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "companies-checkmark" }),
                    _vm._v(" "),
                    _c("input", {
                      attrs: {
                        type: "checkbox",
                        value: "companies-settings",
                        id: "companies-settings"
                      },
                      domProps: { checked: _vm.savedSettings === true }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "company-steps-title",
                        class: {
                          "text-white": _vm.step === "companies-settings"
                        }
                      },
                      [_vm._v("\n          Company Settings")]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "text-center d-inline-block px-4 py-2 text-white companies-check-field",
                class: [
                  _vm.step === "companies-pricing"
                    ? "bg-primary check-default"
                    : "text-dark"
                ]
              },
              [
                _c(
                  "label",
                  {
                    class: [
                      _vm.savedCoverage === true && _vm.savedSettings === true
                        ? "check-open pointer"
                        : ""
                    ],
                    attrs: { for: "companies-pricing" },
                    on: {
                      click: function($event) {
                        _vm.savedCoverage === true && _vm.savedSettings === true
                          ? _vm.setCompanyStep("companies-pricing")
                          : null
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "companies-checkmark" }),
                    _vm._v(" "),
                    _c("input", {
                      attrs: {
                        type: "checkbox",
                        value: "companies-pricing",
                        id: "companies-pricing"
                      },
                      domProps: { checked: _vm.step === "companies-pricing" }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "company-steps-title",
                        class: {
                          "text-white": _vm.step === "companies-pricing"
                        }
                      },
                      [_vm._v("\n          Pricing")]
                    )
                  ]
                )
              ]
            )
          ])
        ]
      )
    : _c("div", [
        _c("nav", [
          _c(
            "div",
            { staticClass: "nav flex-column flex-nowrap overflow-hidden" },
            [
              _c(
                "div",
                {
                  staticClass: "nav-item nav-link pointer",
                  class: [_vm.step === "companies-info" ? "active" : ""],
                  on: {
                    click: function($event) {
                      _vm.setCompanyStep("companies-info")
                    }
                  }
                },
                [_vm._v("\n        Company info\n      ")]
              ),
              _vm._v(" "),
              _vm.canListCompanyCoverages
                ? _c(
                    "div",
                    {
                      staticClass: "nav-item nav-link pointer",
                      class: [_vm.step === "companies-map" ? "active" : ""],
                      on: {
                        click: function($event) {
                          _vm.setCompanyStep("companies-map")
                        }
                      }
                    },
                    [_vm._v("\n        Coverage\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "nav-item nav-link pointer",
                  class: [_vm.step === "companies-settings" ? "active" : ""],
                  on: {
                    click: function($event) {
                      _vm.setCompanyStep("companies-settings")
                    }
                  }
                },
                [_vm._v("\n        Company Settings\n      ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "nav-item nav-link pointer",
                  class: [_vm.step === "companies-pricing" ? "active" : ""],
                  on: {
                    click: function($event) {
                      _vm.setCompanyStep("companies-pricing")
                    }
                  }
                },
                [_vm._v("\n        Pricing\n      ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "nav-item nav-link pointer",
                  class: [
                    _vm.step === "companies-availability" ? "active" : ""
                  ],
                  on: {
                    click: function($event) {
                      _vm.setCompanyStep("companies-availability")
                    }
                  }
                },
                [_vm._v("\n        Availability\n      ")]
              ),
              _vm._v(" "),
              _vm.$_can("companies.mod.update")
                ? _c(
                    "div",
                    {
                      staticClass: "nav-item nav-link pointer",
                      class: [_vm.step === "web-quote" ? "active" : ""],
                      on: {
                        click: function($event) {
                          _vm.setCompanyStep("web-quote")
                        }
                      }
                    },
                    [_vm._v("\n        Web quote\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$_can("companies.mod.update")
                ? _c(
                    "div",
                    {
                      staticClass: "nav-item nav-link pointer",
                      class: [_vm.step === "companies-profile" ? "active" : ""],
                      on: {
                        click: function($event) {
                          _vm.setCompanyStep("companies-profile")
                        }
                      }
                    },
                    [_vm._v("\n        mod24 settings\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$_can("companies.mod.update")
                ? _c(
                    "div",
                    {
                      staticClass: "nav-item nav-link pointer",
                      class: [_vm.step === "billing" ? "active" : ""],
                      on: {
                        click: function($event) {
                          _vm.setCompanyStep("billing")
                        }
                      }
                    },
                    [_vm._v("\n        Billing Info\n      ")]
                  )
                : _vm._e()
            ]
          )
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f2678222", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2678222","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompaniesStepsMenu.vue
// module id = null
// module chunks = 